export class GetIntegrationResponse {
    'integration';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "integration",
            "baseName": "integration",
            "type": "IntegrationConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetIntegrationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
